(function () {
  'use strict';

  function showCartButtonFeedback(btn) {
    if (!btn) return;

    var orig = btn.dataset.ttOrigLabel;
    if (!orig) {
      orig = btn.innerHTML;
      btn.dataset.ttOrigLabel = orig;
    }

    btn.classList.remove('tt-cart-added', 'tt-cart-error');
    btn.innerHTML = '✓';
    btn.classList.add('tt-cart-added');

    setTimeout(function () {
      btn.innerHTML = orig;
      btn.classList.remove('tt-cart-added');
      delete btn.dataset.loading;
      delete btn.dataset.ttOrigLabel;
    }, 900);
  }

  function showCartButtonError(btn, message) {
    if (!btn) return;
    var orig = btn.dataset.ttOrigLabel || btn.innerHTML;
    btn.dataset.ttOrigLabel = orig;
    btn.classList.remove('tt-cart-added');
    btn.classList.add('tt-cart-error');
    btn.innerHTML = '!';
    btn.setAttribute('title', message || 'تعذر إضافة المنتج');
    btn.setAttribute('aria-label', message || 'تعذر إضافة المنتج');

    setTimeout(function () {
      btn.innerHTML = orig;
      btn.classList.remove('tt-cart-error');
      delete btn.dataset.loading;
      delete btn.dataset.ttOrigLabel;
      btn.removeAttribute('title');
    }, 1600);
  }

  function setCartBadgeOnElement(container, itemCount) {
    if (!container) return;

    var badge = container.querySelector('.cart-badge');
    if (itemCount > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'cart-badge';
        if (container.classList.contains('mb-item-cart')) {
          badge.classList.add('mb-cart-badge');
        }
        badge.setAttribute('aria-hidden', 'true');
        var wrap = container.querySelector('.mb-icon-wrap') || container;
        wrap.appendChild(badge);
      }
      badge.textContent = itemCount < 100 ? itemCount : '99+';
    } else if (badge) {
      badge.remove();
    }
  }

  function updateTrikCartBadge(itemCount) {
    setCartBadgeOnElement(document.getElementById('cart-icon-bubble'), itemCount);
    setCartBadgeOnElement(document.getElementById('cart-icon-mobile-bar'), itemCount);
  }

  function bindCartBadgeSyncOnce() {
    if (bindCartBadgeSyncOnce.done) return;
    bindCartBadgeSyncOnce.done = true;

    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.cartData && typeof event.cartData.item_count === 'number') {
        updateTrikCartBadge(event.cartData.item_count);
      }
    });
  }

  function handleQuickAdd(form, btn) {
    if (!form || !btn || btn.disabled || btn.dataset.loading === '1') return;

    if (typeof fetchConfig !== 'function' || !window.routes || !window.routes.cart_add_url) {
      return;
    }

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    // Button-only loading. Do NOT lock page scroll / open overlay yet —
    // early body{position:fixed} caused the white blank screen before the drawer opened.
    btn.dataset.loading = '1';
    if (!btn.dataset.ttOrigLabel) {
      btn.dataset.ttOrigLabel = btn.innerHTML;
    }
    btn.innerHTML = '…';
    btn.setAttribute('aria-busy', 'true');

    var config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    var formData = new FormData(form);
    if (cart) {
      if (cart.tagName === 'CART-DRAWER' && typeof cart.getSectionsToRender === 'function') {
        formData.append(
          'sections',
          cart.getSectionsToRender().map(function (section) {
            return section.id;
          }).join(',')
        );
      } else if (typeof cart.getSectionsToRender === 'function') {
        formData.append(
          'sections',
          cart.getSectionsToRender().map(function (section) {
            return section.id;
          }).join(',')
        );
      } else {
        formData.append('sections', 'cart-drawer');
      }
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(btn);
      }
    }
    config.body = formData;

    fetch(window.routes.cart_add_url, config)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        btn.removeAttribute('aria-busy');

        if (response.status) {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'trik-truk-quick-add',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
          }
          showCartButtonError(btn, response.description || response.message || 'تعذر إضافة المنتج');
          return;
        }

        if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'trik-truk-quick-add',
            productVariantId: formData.get('id'),
            cartData: response,
          });
        }

        if (typeof response.item_count === 'number') {
          updateTrikCartBadge(response.item_count);
        }

        // Paint drawer HTML first, then open (no early overlay / scroll lock)
        if (cart.tagName === 'CART-DRAWER') {
          cart.renderContents(response, { skipIconUpdate: true });
        } else {
          cart.renderContents(response);
        }

        if (cart.classList && cart.classList.contains('is-empty')) {
          cart.classList.remove('is-empty');
        }

        showCartButtonFeedback(btn);
      })
      .catch(function (err) {
        console.error(err);
        btn.removeAttribute('aria-busy');
        showCartButtonError(btn, 'تعذر إضافة المنتج');
      });
  }

  function bindQuickAddOnce() {
    if (bindQuickAddOnce.done) return;
    bindQuickAddOnce.done = true;

    document.addEventListener(
      'click',
      function (e) {
        var btn = e.target.closest('.tt-quick-add .btn-cart, .tt-quick-add .btn-ac');
        if (!btn) return;

        var form = btn.closest('form.tt-quick-add');
        if (!form || !form.closest('.trik-truk-product-grid')) return;

        e.preventDefault();
        e.stopPropagation();
        handleQuickAdd(form, btn);
      },
      true
    );

    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form.matches || !form.matches('form.tt-quick-add')) return;
        if (!form.closest('.trik-truk-product-grid')) return;

        e.preventDefault();
        e.stopPropagation();

        var btn = form.querySelector('.btn-cart, .btn-ac');
        handleQuickAdd(form, btn);
      },
      true
    );
  }

  function bindWishlistOnce() {
    if (bindWishlistOnce.done) return;
    bindWishlistOnce.done = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.trik-truk-product-grid .btn-wishlist');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var on = btn.getAttribute('aria-pressed') === 'true';
      btn.setAttribute('aria-pressed', on ? 'false' : 'true');
      btn.textContent = on ? '♡' : '♥';
      btn.style.color = on ? '' : '#FF6B6B';
      btn.style.borderColor = on ? '' : '#FF6B6B';
    });
  }

  function initMobileBarClass() {
    if (document.querySelector('.trik-truk-mobile-bar-section .mobile-bar')) {
      document.body.classList.add('tt-mobile-bar-enabled');
    }
  }

  function initLcColorSwatches() {
    /* Disabled: custom gallery hooks conflicted with Shopify media-gallery and caused freezes. */
  }

  function applyBuyItNowLabel() {
    var label = (window.variantStrings && window.variantStrings.buyItNow) || 'إشتر الأن';
    document.querySelectorAll('.shopify-payment-button__button--unbranded').forEach(function (btn) {
      if (!btn || btn.getAttribute('data-tt-buy-now') === '1') return;
      btn.textContent = label;
      btn.setAttribute('aria-label', label);
      btn.setAttribute('data-tt-buy-now', '1');
    });
  }

  function localizeCodLabels() {
    var cod = (window.variantStrings && window.variantStrings.codLabel) || 'الدفع عن الاستلام';
    document.querySelectorAll('.pay-chip').forEach(function (el) {
      var text = (el.textContent || '').trim();
      if (/cash on delivery/i.test(text) || /\(cod\)/i.test(text) || text === 'COD') {
        el.textContent = cod;
      }
    });
  }

  function initBuyItNowLabel() {
    if (window.__ttBuyNowInit) return;
    window.__ttBuyNowInit = true;
    applyBuyItNowLabel();

    // Payment buttons are often injected after first paint — re-apply when they appear.
    if (typeof MutationObserver === 'undefined') return;
    var root = document.querySelector('product-form') || document.body;
    var observer = new MutationObserver(function () {
      applyBuyItNowLabel();
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  function bindMobileBarCartOnce() {
    if (bindMobileBarCartOnce.done) return;
    bindMobileBarCartOnce.done = true;

    document.addEventListener('click', function (e) {
      var link = e.target.closest('#cart-icon-mobile-bar');
      if (!link) return;

      var drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.open !== 'function') return;

      e.preventDefault();
      drawer.open(link);
    });
  }

  function initTrikTrukUi() {
    bindQuickAddOnce();
    bindWishlistOnce();
    bindCartBadgeSyncOnce();
    bindMobileBarCartOnce();
    initMobileBarClass();
    localizeCodLabels();
    initBuyItNowLabel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTrikTrukUi);
  } else {
    initTrikTrukUi();
  }

  document.addEventListener('shopify:section:load', initTrikTrukUi);
})();
